// @ts-strict-ignore
import { FilterElement, IFilter } from "@dashboard/components/Filter";
import { MultiAutocompleteChoiceType } from "@dashboard/components/MultiAutocompleteSelectField";
import {
  SubscriptionListUrlFilters,
  SubscriptionListUrlFiltersWithMultipleValues,
} from "@dashboard/orders/urls";
import { getMultipleValueQueryParam } from "@dashboard/utils/filters";
import { createOptionsField } from "@dashboard/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum SubscriptionFilterKeys {
  status = "status",
}

export interface SubscriptionListFilterOpts {
  status: {
    active: boolean;
    choices: MultiAutocompleteChoiceType[];
    value: string[];
  };
}

const messages = defineMessages({
  status: {
    id: "0PUBM9",
    defaultMessage: "Status",
    description: "subscription list filter",
  },
});

const STATUS_OPTIONS: MultiAutocompleteChoiceType[] = [
  { label: "Active", value: "active" },
  { label: "Pending", value: "pending" },
  { label: "Canceled", value: "canceled" },
  { label: "Suspended", value: "suspended" },
  { label: "Completed", value: "completed" },
];

export function getSubscriptionStatusChoices(): MultiAutocompleteChoiceType[] {
  return STATUS_OPTIONS;
}

export function getFilterOpts(
  params: SubscriptionListUrlFilters,
): SubscriptionListFilterOpts {
  return {
    status: {
      active: params.status !== undefined && params.status.length > 0,
      choices: STATUS_OPTIONS,
      value: params.status ?? [],
    },
  };
}

export function createFilterStructure(
  intl: IntlShape,
  opts: SubscriptionListFilterOpts,
): IFilter<SubscriptionFilterKeys> {
  return [
    {
      ...createOptionsField(
        SubscriptionFilterKeys.status,
        intl.formatMessage(messages.status),
        opts.status.value,
        true,
        opts.status.choices,
      ),
      active: opts.status.active,
    },
  ];
}

export function getFilterQueryParam(
  filter: FilterElement<SubscriptionFilterKeys>,
): SubscriptionListUrlFilters {
  const { name } = filter;

  switch (name) {
    case SubscriptionFilterKeys.status:
      return getMultipleValueQueryParam(
        filter,
        SubscriptionListUrlFiltersWithMultipleValues.status,
      );
    default:
      return {};
  }
}
